<template>
  <div>
    <v-select
      :items="relations"
      label="This person's relationship to you."
      v-model="modifyData[modifyIndex].relationship"
      dense
      v-on:change="checkRelation"
      outlined></v-select>
  </div>
</template>

<script>
  import { mapFields } from "vuex-map-fields";
  export default {
    props: {
      modifyData: Array,
      modifyIndex: Number
    },
    mounted () {

    },
    methods: {
      checkRelation(relation) {
        if (["mother", "maternal aunt", "paternal aunt", "maternal grandmother", "paternal grandmother"].includes(relation)) {
          this.modifyData[this.modifyIndex].gender = 'female';
        } else if (["father", "maternal uncle", "paternal uncle", "maternal grandfather", "paternal grandfather"].includes(relation)) {
          this.modifyData[this.modifyIndex].gender = 'male';
        } else {

        }
      }
    },
    data: () => ({
    }),
    computed: {
      ...mapFields("patientQuestion", [
        "dataModel",
        "relations"
      ])
    }
  };
</script>
<style>
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
